import { cx } from "@jugl-web/utils";
import { ReactNode } from "react";
import { FormGroup, FormGroupProps } from "../FormGroup";

export interface UtilityTextInputBaseProps extends FormGroupProps {
  children: ReactNode;
  mask?: string;
  inputId?: string;
  inputWrapperClassName?: string;
}

export const UtilityTextInputBase = (props: UtilityTextInputBaseProps) => {
  const { isInvalid, isDisabled, children, inputWrapperClassName, inputId } =
    props;
  return (
    <FormGroup {...{ ...props, labelFor: inputId }}>
      <div
        className={cx(
          "flex items-center overflow-hidden border-[1px]",
          "rounded-[10px] border-solid border-grey-400 font-secondary text-base leading-4 transition-colors focus-within:border-transparent",
          "focus-within:ring-2 focus-within:outline-none focus:ring-2",
          {
            "focus-within:border-[#90C9F9] focus-within:ring-[#90C9F9]":
              !isInvalid && !isDisabled,
            "border-solid border-gradients-danger focus-within:border-gradients-danger focus-within:ring-gradients-danger hover:border-gradients-danger focus:border-gradients-danger":
              isInvalid,
            "bg-grey-[#FAFAFA] border-dashed border-grey-400 hover:border-grey-400":
              isDisabled,
          },
          inputWrapperClassName
        )}
      >
        {children}
      </div>
    </FormGroup>
  );
};
